import Cookies from 'universal-cookie'
const cookies = new Cookies();

export const header = () => {
  let auth_token = cookies.get('auth_token');
  return {headers:{
    'Authorization':`Bearer ${auth_token}`,
    'Content-Type':'application/json'
  }}
}
export const getUserId = cookies.get('user_id')
